import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;


export const fetchResidentals = createAsyncThunk(
    "residentals/fetchResidentals",
    async (token, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/api/v1/residentials/get-all`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const responseDataError = await response.json();
                return rejectWithValue(responseDataError.error || "Ошибка загрузки");
            }

            return await response.json();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const addResidental = createAsyncThunk(
    "residentals/addResidental",
    async ({ sendData, token }, { rejectWithValue, dispatch }) => {
        try {
            const response = await fetch(`${API_URL}/api/v1/residentials`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(sendData),
            });

            if (!response.ok) {
                const responseDataError = await response.json();
                toast.error("Ошибка добавления");
                return rejectWithValue(responseDataError.error || "Ошибка добавления");
            }

            await response.json();
            toast.success("ЖК успешно создан");
            dispatch(fetchResidentals(token));
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const deleteResidental = createAsyncThunk(
    "residentals/deleteResidental",
    async ({ id, token }, { rejectWithValue, dispatch }) => {
        try {
            const response = await fetch(`${API_URL}/api/v1/residentials/${id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const responseDataError = await response.json();
                toast.error("Ошибка удаления");
                return rejectWithValue(responseDataError.error || "Ошибка удаления");
            }

            toast.success("ЖК успешно удален");
            dispatch(fetchResidentals(token));
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


const residentalsSlice = createSlice({
    name: "residentals",
    initialState: {
        residentals: [],
        status: null,
        error: null,
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(fetchResidentals.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchResidentals.fulfilled, (state, action) => {
                state.loading = false;
                state.residentals = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(fetchResidentals.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(addResidental.pending, (state) => {
                state.loading = true;
            })
            .addCase(addResidental.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(addResidental.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(deleteResidental.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteResidental.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(deleteResidental.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default residentalsSlice.reducer;
